import React from "react";
import styles from "./ota-update-card.module.scss";
import OTAUpdateSummary from "../ota-update-summary/ota-update-summary";
import OTAReleaseNotes from "../ota-release-notes/ota-release-notes";
import { OTA_UPDATE_CARD as cssClassName } from "../../../cloud-connect/ota-update/constants";
import {
  ActiveInstallationProcessPayload,
  ListItem,
} from "@src/types/ota-update";
// Props definition for OTA update card component
interface OTAUpdateCardProps {
  cardData: ListItem | null;
  onInstallStarted?: (updateId: string) => void;
  activeOTAHistoryTab: string;
  onSelectPushFirmwareRow?: React.Dispatch<
    React.SetStateAction<ListItem | null>
  >;
  onSelectPushFirmwareBackupRow?: React.Dispatch<
    React.SetStateAction<ListItem | null>
  >;
  activeInstallationData: ActiveInstallationProcessPayload | null;
}

// Renders OTA update summary along with release notes details
const OTAUpdateCard = ({
  cardData,
  onInstallStarted,
  activeOTAHistoryTab,
  onSelectPushFirmwareRow,
  onSelectPushFirmwareBackupRow,
  activeInstallationData,
}: OTAUpdateCardProps) => {
  return (
    // Main container for OTA update card layout
    <section className={styles[cssClassName]}>
      {/* Component displaying update metadata and file details */}
      <OTAUpdateSummary
        cardData={cardData}
        onInstallStarted={onInstallStarted}
        activeOTAHistoryTab={activeOTAHistoryTab}
        onSelectPushFirmwareRow={onSelectPushFirmwareRow}
        onSelectPushFirmwareBackupRow={onSelectPushFirmwareBackupRow}
        activeInstallationData={activeInstallationData}
      />

      {/* Component displaying categorized release notes information */}
      <OTAReleaseNotes
        cardData={cardData}
        width={50}
        activeOTAHistoryTab={activeOTAHistoryTab}
      />
    </section>
  );
};

export default OTAUpdateCard;
